import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m20.905 10.713 2.928-2.217-2.882-4.993-3.39 1.43a8.988 8.988 0 0 0-2.223-1.29L14.883 0H9.117l-.455 3.643c-.8.321-1.548.756-2.224 1.29L3.05 3.503.167 8.497l2.927 2.217a8.9 8.9 0 0 0 0 2.574L.167 15.504l2.882 4.993 3.39-1.43a8.986 8.986 0 0 0 2.223 1.29L9.117 24h5.766l.455-3.643a8.988 8.988 0 0 0 2.223-1.29l3.39 1.43 2.882-4.993-2.927-2.217a9.44 9.44 0 0 0 .083-.855l.01-.434c0-.43-.032-.86-.093-1.285Zm-2.07 2.785-.137.626 2.52 1.908-1.117 1.936-2.92-1.233-.474.434a6.988 6.988 0 0 1-2.59 1.504l-.608.194L13.117 22h-2.234l-.392-3.133-.608-.194a6.988 6.988 0 0 1-2.59-1.504l-.473-.434-2.922 1.233-1.117-1.936 2.522-1.91-.139-.626a6.9 6.9 0 0 1 0-2.992l.14-.627-2.523-1.91 1.117-1.934L6.82 7.264l.473-.434a6.987 6.987 0 0 1 2.59-1.504l.608-.194L10.883 2h2.234l.392 3.133.608.194a6.987 6.987 0 0 1 2.59 1.504l.473.434 2.921-1.232 1.117 1.935-2.52 1.908.137.626c.087.393.14.794.158 1.196L19 12a7.047 7.047 0 0 1-.165 1.498Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionSettings24 = createIcon(IconComponent);